import { defineContent } from './defineContent.js';
import data from './services.json';
import { servicesSchema } from './services.schema.js';

export const services = defineContent(servicesSchema, data);
